module.exports = __webpack_public_path__ + "img/Credit_Saison.796bfe8d.svg";